var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wheel-home-game-character" },
    [
      _c("Spine", {
        attrs: {
          "model-name": "cop_wheel",
          zoom: 0.65,
          "assets-path": _vm.assetsDir,
          "animation-name": _vm.animationName,
          loop: _vm.loop,
          fps: 30,
          "static-animation-name": _vm.staticAnimationName,
        },
        on: { animationComplete: _vm.onAnimationComplete },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }